import beautifier from 'js-beautify'
import axios from 'axios'  // axios 직접 import 권장

const getDefaultState = () => ({
  testDataInput: '',
  testDataOutput: '',
  testDataOutputFormat: null
})

export default({
  namespaced: true,
  state: getDefaultState,

mutations: {
  populateTestDataInput(state, inputTemplate) {
    state.testDataInput = beautifier.js_beautify(inputTemplate, {
      indent_size: 4
    })
  },
  populateTestDataOutput(state, generatedTestData) {
    state.testDataOutput = generatedTestData
  },
  populateOutputFormat(state, outputFormat) {
    state.testDataOutputFormat = outputFormat
  }
},
actions: {
  async testdataGenerator({ commit, state }) {
    if (
      state.testDataInput !== '' &&
      state.testDataInput !== '{}' &&
      Object.keys(state.testDataInput).length !== 0
    ) {
      try {
        JSON.parse(state.testDataInput)
      } catch (e) {
        const message =
          'Invalid entries in Input Template JSON, Please check and provide Testdata input template in valid JSON Format. Error: ' +
          e
        commit('populateTestDataOutput', message)
        return
      }

      const headers = { 'Content-Type': 'application/json' }
      try {
        const response = await axios.post(
          `/api/gen/generateTestData`,
          JSON.parse(state.testDataInput),
          { headers }
        )

        if (state.testDataOutputFormat === 'application/xml') {
          try {
            const xmlResponse = await axios.post(
              '/generateTestDataXML',
              JSON.parse(JSON.stringify(response.data)),
              { headers }
            )
            commit('populateTestDataOutput', xmlResponse.data)
          } catch (error) {
            commit(
              'populateTestDataOutput',
              'Exception occured during the events generation in XML format, Error : ' +
                JSON.stringify(error, null, 4)
            )
          }
        } else {
          commit('populateTestDataOutput', response.data)
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.type &&
          error.response.data.detail
        ) {
          commit(
            'populateTestDataOutput',
            error.response.data.type +
              ', ' +
              error.response.data.title +
              ':\n' +
              error.response.data.detail.replace(
                /(?![^\n]{1,75}$)([^\n]{1,75})\s/g,
                '$1\n'
              )
          )
        } else if (error.response) {
          commit(
            'populateTestDataOutput',
            'Exception occured during the events generation, Error : ' +
              JSON.stringify(error.response, null, 4)
          )
        } else {
          commit(
            'populateTestDataOutput',
            'Unable to generate events something went wrong, Please save/export the InputTemplate and/or Design data for further validations'
          )
        }
      }
    }
  }
}
})
